import React, { useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Tooltip,
    IconButton,
    Typography, Button,useMediaQuery
} from "@mui/material";
import {MessagesSquare} from "lucide-react";
import {useTranslation} from "react-i18next";
import ChatScreen from "./ChatScreen";
import {Close} from "@mui/icons-material";
import {theme} from "../../../config/design/theme";

const ChatButton = ({sender,receiver,order,title,reload,icon,className,color,variant}) => {
    const { t } = useTranslation();

    const [open, setOpen] = useState(false);
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const toggleOpen = () => {
        setOpen((prev) => !prev);
        if(!!reload){
            reload();
        }

    }

    return (
        <>
            <Button
                color={color}
                variant={variant}
                onClick={toggleOpen}
                className={className}
                startIcon={!!icon ? icon : <MessagesSquare/>}
            >
                {!!title ? title : t('chat')}
            </Button>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={toggleOpen}
                open={open}
                fullScreen={!!isMobile}
            >
                <DialogTitle className="dialog-title">
                    {!!title ? title : t('chat')}
                    <IconButton
                        onClick={() => toggleOpen()}
                        style={{position:"absolute",right:15,top:15}}
                        size="small"
                    >
                        <Close className="lucide-icon"/>
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <ChatScreen sender={sender} receiver={receiver} order={order}/>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default ChatButton;
